import AuthContainer from './containers/AuthContainer'

export default AuthContainer
